var React = require('react');

function Polygon (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"0 0, 60 0, 30 42","style":{"fill":"#FFFFFF"}}));
}

Polygon.defaultProps = {"viewBox":"0 0 60 42","width":"60","height":"42"};

module.exports = Polygon;

Polygon.default = Polygon;
